module.exports = __webpack_public_path__ + "static/media/g5.eb1ec3be.jpg";